import { createSelector, defaultMemoize } from 'reselect';

import { propertiesSelector } from './properties';
import { subselect } from './root';

const memoizedRating = defaultMemoize((rating, ratings) =>
  ratings[rating]
    ? ratings[rating].image
      ? ratings[rating].image
      : ratings[rating].displayName
    : null,
);

const getRatingByNameSelector = createSelector([propertiesSelector], ({ data = {} }) => (rating) =>
  memoizedRating(rating, data),
);

export const getRatingSelector = subselect(getRatingByNameSelector);
